// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import { getIconPath } from '../../../../../utils';
import styles from '../Notification.style';
import withStyles from '../../../hoc/withStyles';
/**
 *
 * @param {String} className -  classname for the parent container
 * @param {String} status - to show error or success message
 * @param {String} message - error message
 * @param {node} children - notification child nodes.
 */
// eslint-disable-next-line complexity
const Notification = ({
  className,
  status,
  alt,
  message,
  children,
  scrollIntoView,
  isErrorTriangleIcon,
  spc,
  isError,
  isCloseable,
  onClose,
}) => {
  const successIcon = getIconPath('circle-check-fill');
  const errorIcon = isErrorTriangleIcon
    ? getIconPath('alert-triangle')
    : getIconPath('circle-error-fill');
  const infoIcon = getIconPath('circle-info-fill');
  const warningIcon = getIconPath('circle-warning-fill');
  const spcErrorIcon = getIconPath('icons-error-message');
  const spcWarningIcon = getIconPath('icons-warning-message');

  let imageAlt = '';
  let imageSrc = '';
  if (status === 'success') {
    imageSrc = successIcon;
    imageAlt = alt || 'success icon';
  }
  if (status === 'error') {
    imageSrc = !spc ? errorIcon : spcErrorIcon;
    imageAlt = alt || 'error icon';
  }
  if (status === 'info') {
    imageSrc = infoIcon;
    imageAlt = alt || 'info icon';
  }
  if (status === 'warning') {
    imageSrc = !spc ? warningIcon : spcWarningIcon;
    imageAlt = alt || 'warning icon';
  }
  const isRichText = typeof message === 'string' ? message?.indexOf('<') > -1 : false;
  // For window scroll up to top once component gets loaded.
  useEffect(() => {
    if (scrollIntoView) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, []);

  return (
    <div
      className={`${className} elem-pt-SM elem-pr-LRG elem-pb-SM elem-pl-LRG elem-mb-LRG notification-container`}
      role="alert"
    >
      <img alt={imageAlt} src={imageSrc} className="notification__image elem-mr-XS" />
      {isRichText ? (
        <RichText richTextHtml={message} />
      ) : (
        <BodyCopy
          color={isError && 'error'}
          fontSize="fs14"
          fontWeight={!spc ? 'extrabold' : undefined}
          fontFamily="secondary"
        >
          {message}
          {children}
        </BodyCopy>
      )}
      {isCloseable && (
        <span
          onClick={onClose}
          onKeyDown={onClose}
          role="button"
          tabIndex={0}
          className="close-icon"
        >
          <img alt="close" src={getIconPath('close-cross')} width={15} height={15} />
        </span>
      )}
    </div>
  );
};

Notification.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  alt: PropTypes.string,
  children: PropTypes.node,
  scrollIntoView: PropTypes.bool,
  isErrorTriangleIcon: PropTypes.bool,
  spc: PropTypes.bool,
  isResetFontWeight: PropTypes.bool,
  isCloseable: PropTypes.bool,
  onClose: PropTypes.func,
};

Notification.defaultProps = {
  className: '',
  children: null,
  alt: '',
  scrollIntoView: false,
  isErrorTriangleIcon: false,
  spc: false,
  isResetFontWeight: false,
  isCloseable: false,
  onClose: () => {},
};

export default withStyles(Notification, styles);
export { Notification as NotificationVanilla };
